"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOrders = void 0;
class GetOrders {
    constructor(orderRepository) {
        this.orderRepository = orderRepository;
    }
    execute(request) {
        return this.orderRepository.getOrders(request);
    }
}
exports.GetOrders = GetOrders;
